import {
    IRestaurantMenuItemTranslation,
    MenuEntityType,
} from "@/shared/api/restaurant-menus"
import { RestaurantMenuEntityTarget } from "../model/types"

interface MenuTranslationsTabProps {
    translations: IRestaurantMenuItemTranslation[]
    onOpenTranslations: (target: RestaurantMenuEntityTarget) => void
}

const isMenuEntityType = (value?: string): value is MenuEntityType => {
    return value === "category" || value === "item" || value === "modifier"
}

export const MenuTranslationsTab = ({ translations, onOpenTranslations }: MenuTranslationsTabProps) => {
    if (translations.length === 0) {
        return (
            <div className="info_panel">
                Переводов нет
            </div>
        )
    }

    return (
        <div className="table_box">
            <div className="overflow-auto">
                <table className="react-table">
                    <thead>
                        <tr>
                            <th>item_type</th>
                            <th>item_id</th>
                            <th>language_code</th>
                            <th>name</th>
                            <th>description</th>
                            <th>Действия</th>
                        </tr>
                    </thead>
                    <tbody>
                        {translations.map((translation, index) => {
                            const canEdit = isMenuEntityType(translation.item_type) && Boolean(translation.item_id)

                            return (
                                <tr key={`${translation.item_type ?? "type"}-${translation.item_id ?? "id"}-${translation.language_code ?? "language"}-${index}`}>
                                    <td>{translation.item_type || "—"}</td>
                                    <td>{translation.item_id || "—"}</td>
                                    <td>{translation.language_code || "—"}</td>
                                    <td>{translation.name || "—"}</td>
                                    <td>{translation.description || "—"}</td>
                                    <td>
                                        <button
                                            type="button"
                                            disabled={!canEdit}
                                            onClick={() => {
                                                if (!isMenuEntityType(translation.item_type) || !translation.item_id) {
                                                    return
                                                }

                                                onOpenTranslations({
                                                    entityType: translation.item_type,
                                                    entityId: translation.item_id,
                                                    title: translation.name || translation.item_id,
                                                })
                                            }}
                                            className="form_handle_button !h-9 !w-auto px-4 disabled:opacity-50"
                                        >
                                            Переводы
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}
